// @flow

export const AUDIT_LOGS_LIMIT = 50;
